// MathJax utility functions for consistent mathematical expression rendering

export const renderMathJax = (delay = 100) => {
  return new Promise((resolve) => {
    const timer = setTimeout(() => {
      if (window.MathJax && window.MathJax.typesetPromise) {
        // Clear any existing MathJax content first
        window.MathJax.typesetClear();
        
        // Re-process all math content
        window.MathJax.typesetPromise()
          .then(() => {
            resolve(true);
          })
          .catch((err) => {
            console.warn('MathJax rendering error:', err);
            resolve(false);
          });
      } else {
        console.warn('MathJax not available');
        resolve(false);
      }
    }, delay);
  });
};

export const useMathJax = (dependencies = []) => {
  const React = require('react');
  
  React.useEffect(() => {
    renderMathJax(150);
  }, dependencies);
};

export const formatMathExpression = (expression) => {
  if (!expression) return '';
  
  // If it's already wrapped in $ signs, return as is
  if (expression.startsWith('$') && expression.endsWith('$')) {
    return expression;
  }
  
  // If it contains LaTeX commands, wrap in $ signs
  if (expression.includes('\\') || expression.includes('^') || expression.includes('_')) {
    return `$${expression}$`;
  }
  
  return expression;
};

export const ensureMathJaxReady = () => {
  return new Promise((resolve) => {
    if (window.MathJax && window.MathJax.typesetPromise) {
      resolve(true);
    } else {
      // Wait for MathJax to load
      let attempts = 0;
      const maxAttempts = 50; // 5 seconds max
      
      const checkMathJax = () => {
        if (window.MathJax && window.MathJax.typesetPromise) {
          resolve(true);
        } else if (attempts < maxAttempts) {
          attempts++;
          setTimeout(checkMathJax, 100);
        } else {
          console.warn('MathJax failed to load within timeout');
          resolve(false);
        }
      };
      
      checkMathJax();
    }
  });
}; 